<template>
  <section id="page-intro-pattern">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-dark">
          <h3>{{ title }}</h3>
        </div>

        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '../utils/Clearfix'

  Vue.use(VueAxios, axios)

  export default {
    props: { title: String },
    components: { Clearfix }
  }
</script>

<style>
  #page-intro-pattern {
    background: url('../../assets/img/bg/pattern.jpg') 50% 0 fixed;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// SectionIntroPattern.vue?68311c98